import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { translate } from '@jsverse/transloco';
import { getFormErrorMessage } from '@app/core/utils/form-error-message.util';

@Component({
  standalone: true,
  selector: 'ups-pin',
  host: { class: 'd-block cursor-pointer' },
  templateUrl: './form-pin.component.html',
  styleUrls: ['./form-pin.component.scss'],
  imports: [ 
    IonicModule,
    ReactiveFormsModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormPinComponent
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: FormPinComponent
    }
  ]
})
export class FormPinComponent implements ControlValueAccessor, Validator {

  @Input() public obsecure: boolean = true;
  @Input() public label: string = translate('form.otp');
  public readonly arr: Array<number> = [ 0, 1, 2, 3, 4, 5 ];
  public errorMsg: string = '';
  public formControl!: AbstractControl;
  public isTouched: boolean = false;
  public value: string = '';
  protected onChange: (_val: any) => void = (_val: any) => {};
  protected onTouched: () => void = () => {};

  constructor(
    protected readonly ch: ChangeDetectorRef
  ) {}

  public registerOnChange(fn: any): void{ this.onChange = fn; }
  
  public registerOnTouched(fn: any): void{ this.onTouched = fn; } 

  public setPin(p: any): void{ p.setFocus(); }

  public validate(control: AbstractControl): ValidationErrors | null{
    this.formControl = control;
    return null;
  }
  
  public writeValue(val: any): void{ 
    this.value = val; 
    this.ch.markForCheck();
  }

  public input({ value }: any): void{
    if (!this.isTouched) {
      this.onTouched();
      this.isTouched = true;
    }

    this.value = value;
    this.onChange(this.value);
  }
  
  public validatePin(): void{
    if (!this.formControl.touched) return;
    this.errorMsg = getFormErrorMessage(this.formControl.errors, this.label);
  }
}
